import React, { useEffect, useState } from "react";
import { Card, Progress } from "semantic-ui-react";
import http from "utilities/http";

function ProductCard({ product, style, ...rest }) {
	const [stockQuantity, setStockQuantity] = useState(0);

	useEffect(() => {
		http.get("/stock/byProduct/" + product._id).then((response) => {
			const { stockQuantity } = response.data;
			setStockQuantity(parseFloat(stockQuantity));
		});
	}, [product._id]);

	return (
		<Card
			{...rest}
			style={{
				...style,
				position: "relative",
				padding: "10px 20px 60px 20px",
			}}
		>
			<Card.Header>
				<h4 key={product._id}>
					{product.name}{" "}
					<span
						style={{
							color: "#9a9a9a",
							fontWeight: "500",
							fontSize: "14px",
							marginLeft: "5px",
						}}
					>
						{product.localName}
					</span>
				</h4>
			</Card.Header>
			<Card.Meta>{product.category?.name || "Uncategorised"}</Card.Meta>
			<Card.Description
				style={{
					width: "calc(100% - 40px)",
					boxSizing: "border-box",
					position: "absolute",
					bottom: "-5px",
				}}
			>
				<p style={{ fontSize: "14px", marginBottom: "2px" }}>
					{!stockQuantity
						? "No stock left. Re-order."
						: stockQuantity <= parseFloat(product.threshold)
						? `Only ${stockQuantity} unit(s) left.`
						: `${stockQuantity} unit(s) in stock.`}
				</p>
				<Progress
					total={product.threshold}
					value={stockQuantity}
					size="tiny"
					error={!stockQuantity}
					warning={
						stockQuantity &&
						stockQuantity <= parseFloat(product.threshold)
					}
					success={stockQuantity > parseFloat(product.threshold)}
				/>
			</Card.Description>
		</Card>
	);
}

export default ProductCard;
